import { Link } from 'react-router-dom';
import { companyInfo } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-950 text-slate-300 border-t border-navy-900">
      {/* Main Footer Content */}
      <div className="mx-auto max-w-7xl px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Column 1: Brand & Description */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block focus:outline-none">
              <span className="font-display text-2xl font-bold text-white tracking-tight">
                Know<span className="text-gold-500">How</span> <span className="font-semibold text-white">GROUP</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
              En privat investeringsvirksomhed med fokus på langsigtet værdiskabelse, strategiske partnerskaber og bæredygtig erhvervsudvikling.
            </p>
          </div>

          {/* Column 2: Navigation Links */}
          <div className="flex flex-col gap-6 md:pl-12">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3 text-sm">
              <Link 
                to="/" 
                className="hover:text-gold-500 transition-colors duration-300 focus:outline-none focus:underline"
              >
                Forside
              </Link>
              <Link 
                to="/om-os" 
                className="hover:text-gold-500 transition-colors duration-300 focus:outline-none focus:underline"
              >
                Om os
              </Link>
              <Link 
                to="/kontakt" 
                className="hover:text-gold-500 transition-colors duration-300 focus:outline-none focus:underline"
              >
                Kontakt
              </Link>
            </nav>
          </div>

          {/* Column 3: Contact Info */}
          <div className="flex flex-col gap-6">
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white">
              Kontakt
            </h4>
            <div className="flex flex-col gap-4 text-sm leading-relaxed">
              <div className="flex items-start gap-3">
                <i className="fa-light fa-location-dot text-gold-500 mt-1" aria-hidden="true" />
                <span>{companyInfo.address}</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-light fa-phone text-gold-500" aria-hidden="true" />
                <a 
                  href={`tel:${companyInfo.phone.replace(/\s+/g, '')}`} 
                  className="hover:text-gold-500 transition-colors duration-300 whitespace-nowrap focus:outline-none focus:underline"
                >
                  {companyInfo.phone}
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="fa-light fa-envelope text-gold-500" aria-hidden="true" />
                <a 
                  href={`mailto:${companyInfo.email}`} 
                  className="hover:text-gold-500 transition-colors duration-300 whitespace-nowrap focus:outline-none focus:underline"
                >
                  {companyInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Bar */}
      <div className="border-t border-navy-900 bg-navy-950/50 py-8">
        <div className="mx-auto max-w-7xl px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {currentYear} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
          <p className="tracking-wider uppercase text-[10px] text-slate-400">{companyInfo.branch}</p>
        </div>
      </div>
    </footer>
  );
}
